import { Component, OnInit } from '@angular/core';
import { BaseSpinnerOverlayComponent } from '../base-spinner-overlay.component';

const COMPONENT_SELECTOR = 'wlm-spinner-overlay';

@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './spinner-overlay.component.html',
    styleUrls: ['./spinner-overlay.component.scss'],
    standalone: false
})
export class SpinnerOverlayComponent extends BaseSpinnerOverlayComponent implements OnInit {
  ngOnInit(): void {}

  onSelfClose(): void {
    this.forceCloseLoading$.next();
  }
}
